export default class TopNavigation {
    constructor(elm) {

        this.header = elm;

        /* Burger Menu Toggle */
        this.header.querySelector('.header__burger-menu').addEventListener('click', e => {
            e.preventDefault();
            document.body.classList.toggle('mobile-menu-open', !document.body.classList.contains('mobile-menu-open'));
            const opendropdown = document.querySelectorAll('.nav-item.dropdown');
            opendropdown.forEach(navItem => {
                if (navItem.classList.contains('active')) {
                    navItem.classList.remove('active');
                }
            })
            
        });

        /* Main Menu Dropdown */
        this.header.querySelectorAll('[data-open-dropdown-menu]').forEach(function(dropdownArrowElm){
            dropdownArrowElm.addEventListener('click', e => {
                let childNavItems = e.target.closest('.nav-item');
                let alreadyActiveSelf = childNavItems.classList.contains('nav-item--active');              
                const opendropdown = document.querySelectorAll('.nav-item--active');                
                opendropdown.forEach(navItem => {
                    if (navItem.classList.contains('nav-item--active')) {
                        navItem.classList.remove('nav-item--active');
                    }
                });
                if (!alreadyActiveSelf) {

                    childNavItems.classList.add('nav-item--active');
                }                
            });
        })

        // display/ hide search
        document.addEventListener('click', e => {
            // check if it's desktop size window
            if (window.innerWidth > 991) {
                if (!e.target.closest('.header-search') && !e.target.classList.contains('search-query') && !e.target.classList.contains('search-input') && document.querySelector('.site-search').classList.contains('site-search--active')) {

                    

                        document.querySelector('.site-search').classList.remove('site-search--active');
                    }
                

            }
            else {
                if (!e.target.closest('.header-mobile__search') && !e.target.classList.contains('search-query') && !e.target.classList.contains('search-input') && document.querySelector('.site-search').classList.contains('site-search--active')) {

                    
                        document.querySelector('.site-search').classList.remove('site-search--active');
                    
                }
            }
            
        });

        /* Header search */
        this.header.querySelector('[data-header-search]').addEventListener('click', e => {
            document.querySelector('.site-search').classList.toggle('site-search--active');
        })

        /* Mobile Header search */
        this.header.querySelector('[data-header-mobile-search]').addEventListener('click', e => {
            document.querySelector('.site-search').classList.toggle('site-search--active');
        })

        

        /* Site Menu Toggle */
        const siteLinkDropdown = this.header.querySelector('[data-open-site-link-dropdown]');
        siteLinkDropdown.addEventListener('click', e => {
            siteLinkDropdown.classList.toggle('open', !siteLinkDropdown.classList.contains('open'));
        });

        window.addEventListener('click', e => {
            if (!e.target.closest('.dropdown')) {
                const opendropdown = document.querySelectorAll('.nav-item--active');
                opendropdown.forEach(open => {

                    open.classList.remove('nav-item--active');

                })
            }

            if (!e.target.closest('.site-link-dropdown')) {
                siteLinkDropdown.classList.remove('open');
            }
        })
    }
}
